module.exports = __webpack_public_path__ + "img/token-expired.dbde5675.svg";